import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { categories } from "../../../../constants/commonConstants";

// // Imports Icons
// import HandyManServicesIcon from "../../../../assets/landing/handyman-services.svg";
// import HomeServiceIcon from "../../../../assets/landing/homeService.svg";
// import PersonalAssistIcon from "../../../../assets/landing/PersonalAssistant.svg";
// import TailorIcon from "../../../../assets/landing/Tailor.svg";
// import PhotographerIcon from "../../../../assets/landing/photographer.svg";
// import GradeningIcon from "../../../../assets/landing/Gardening.svg";
// import PaintingIcon from "../../../../assets/landing/Painting.svg";

const CategoryFeaturesSwiper = () => {
  return (
    <div className="relative mx-3 sm:mx-4 md:mx-6">
      {/* Navigation Buttons - Hidden on mobile */}
      <button className="custom-prev hidden md:flex absolute -left-8 top-1/2 transform -translate-y-1/2 z-10 bg-[#C1C3C3] items-center justify-center text-white w-12 h-12 md:w-[64px] md:h-[64px] rounded-full shadow-lg hover:bg-primary-light transition-colors">
        <FaArrowRight className="transform rotate-180 text-content" />
      </button>
      <button className="custom-next hidden md:flex absolute -right-8 top-1/2 transform -translate-y-1/2 z-10 bg-[#C1C3C3] text-white w-12 h-12 md:w-[64px] md:h-[64px] items-center justify-center rounded-full shadow-lg hover:bg-primary-light transition-colors">
        <FaArrowRight className="text-content" />
      </button>

      <Swiper
        spaceBetween={12}
        slidesPerView={1}
        breakpoints={{
          340: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          540: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 6,
            spaceBetween: 20,
          },
        }}
        navigation={{
          prevEl: ".custom-prev",
          nextEl: ".custom-next",
        }}
        className="w-full"
        modules={[Navigation]}
      >
        {categories?.filter(it => it?.primary)?.map((category, index) => (
          <SwiperSlide key={index}>
            <CategoryCard icon={category?.icon} title={category?.name} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

// NOTE: Remove Photography and Personal assistance categories and add Plumbing , electrical , moving services
// const categories = [
//   { icon: HandyManServicesIcon, title: "General Handyman Services" },
//   { icon: TailorIcon, title: "Tailor Services" },
//   { icon: PhotographerIcon, title: "Photography Services" },
//   { icon: HomeServiceIcon, title: "Cleaning Services" },
//   { icon: PersonalAssistIcon, title: "Personal Assistance" },
//   { icon: GradeningIcon, title: "Gardening Services" },
//   { icon: PaintingIcon, title: "Painting and Decorating" },
// ];

const CategoryCard = ({ icon, title, }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const encodedCategory = encodeURIComponent(title).replace(/%20/g, "+");
    const url = `/client/find-service-pro?category=${encodedCategory}`;
    console.log("Navigating to: ", url);
    navigate(url);
  
  };
  return (
    <div className="flex cursor-pointer flex-col items-center justify-center w-full h-[120px] sm:h-[140px] md:h-[164px] p-3 sm:p-4 md:p-6 bg-primary rounded-[12px] sm:rounded-[16px] md:rounded-[20px] transition-all hover:scale-95"
    onClick={handleClick}
    >
      <img
        src={icon}
        alt={title}
        className="w-12 h-12 sm:w-16 sm:h-16 md:w-[84px] md:h-[84px] object-contain mb-2 md:mb-3"
        
      />
      <span className="text-white font-inter text-sm sm:text-base md:text-[16px] font-semibold leading-tight sm:leading-6 text-center">
        {title}
      </span>
    </div>
  );
};

export default CategoryFeaturesSwiper;
